import React from 'react';
import { path } from 'ramda';
import { useTheme } from 'common/styling/theme';
import { StyledListUtil } from 'common/styling/mixins';
import { useIntl } from 'common/config/i18n';

import Button from '../../molecules/button';
import styled from 'styled-components';
import { Space } from 'antd';

const { StyledListButtonWrapper, StyledListBodyWrapper } = StyledListUtil;

const Warning = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: red;
  margin: 15px 0px;
`;
export interface Props {
  title: string | React.ReactElement;
  onConfirm: (b: boolean) => void;
  row?: boolean;
  labelConfirm?: string;
  labelCancel?: string;
  btnCancelWidth?: string;
  btnConfirmWidth?: string;
  warningMessage?: string;
  hideCancel?: boolean;
}

const StyledContent = styled.div`
  margin-top: 20px;
`;
const ModalContentConfirm: React.FC<Props> = (props) => {
  const {
    title,
    onConfirm,
    row,
    labelConfirm,
    labelCancel,
    btnCancelWidth,
    btnConfirmWidth,
    warningMessage,
    hideCancel,
  } = props;
  const { t } = useIntl();
  const { theme } = useTheme();

  return (
    <StyledContent>
      <StyledListBodyWrapper>{title}</StyledListBodyWrapper>
      <StyledListButtonWrapper style={row ? { display: 'flex', justifyContent: 'space-between' } : { display: 'flex' }}>
        <Space
          direction={row ? 'horizontal' : 'vertical'}
          size="small"
          align="start"
          style={{ justifyContent: 'inherit', flex: 1 }}
        >
          <Button hidden={hideCancel} margin="5px" onClick={() => onConfirm(false)} width={btnCancelWidth}>
            {labelCancel || t('Modal', 'CONFIRM_NO')}
          </Button>
          <Button
            margin="5px"
            backgroundColor={path(['colors', 'secondary', 'main'], theme)}
            onClick={() => onConfirm(true)}
            width={btnConfirmWidth}
          >
            {labelConfirm || t('Modal', 'CONFIRM_YES')}
          </Button>
        </Space>
        {warningMessage && (
          <Space direction="vertical" size="small" align="end" style={{ paddingLeft: '24px' }}>
            <Warning>{warningMessage}</Warning>
          </Space>
        )}
      </StyledListButtonWrapper>
    </StyledContent>
  );
};

export default ModalContentConfirm;
